module.exports = __webpack_public_path__ + "img/windows.d96c8793.svg";